import { useEffect } from 'react';
import useCustomNavigation from './useCustomNavigation';
import useUserContext from './useUserContext';

const useGoToHome = () => {
  const navigate = useCustomNavigation();
  const { user } = useUserContext();
  useEffect(() => {
    if (user.homePageUrl && user.homePageUrl !== '') {
      navigate(user.homePageUrl);
    }
  }, [user.homePageUrl, navigate]);
};

export default useGoToHome;
